module.exports = __webpack_public_path__ + "static/media/retweet.e7cbcb45.svg";